interface SectionHeadProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
}

export default function SectionHead({ eyebrow, title, desc, align = "center" }: SectionHeadProps) {
  const isCenter = align === "center";
  return (
    <div className={`flex flex-col ${isCenter ? "items-center text-center" : "items-start text-left"} gap-3 md:gap-4`}>
      <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3.5 py-1 text-xs font-semibold tracking-wide text-primary-800 whitespace-nowrap">
        {eyebrow}
      </span>
      <h2 className="text-2xl md:text-4xl leading-tight text-foreground-950">{title}</h2>
      {desc ? <p className={`max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600 ${isCenter ? "mx-auto" : ""}`}>{desc}</p> : null}
    </div>
  );
}